<div [class.chat-input-focused]="isInputFocused" class="chat-container pb-4 md:p-4 overflow-hidden">
  <div class="chat-window shadow-xl flex flex-col transition-all duration-500 ease-in-out" [ngClass]="{
      'chat-window-collapsed': !messages || messages.length === 0,
      'chat-window-expanded': messages && messages.length > 0
    }" [class.chat-input-focused]="isInputFocused">
    <!-- Loader -->
    <div *ngIf="loading" class="loader">
      <div class="spinner"></div>
      Loading messages...
    </div>

    <!-- Header -->
    <div class="chat-header p-3.5 flex-shrink-0">
      <div class="flex items-center w-full gap-3">
        <!-- Brand Crest Avatar -->
        <div class="w-10 h-10 rounded-xl bg-gradient-to-br from-[#C71650] to-[#0D070C] border border-[#E7CA96]/30 flex items-center justify-center shadow-md relative shrink-0">
          <img src="/mainLogo.webp" alt="Luckycrest" class="w-7 h-5 object-contain" />
          <span class="absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full bg-emerald-500 border-2 border-[#0D070C]"></span>
        </div>
        <!-- Title & Status -->
        <div class="flex flex-col">
          <h1 class="text-white text-sm font-bold tracking-wide flex items-center gap-1.5">
            VIP SUPPORT
            <span class="text-[9px] font-extrabold text-[#E7CA96] bg-[#E7CA96]/15 px-1.5 py-0.5 rounded border border-[#E7CA96]/30">24/7</span>
          </h1>
          <span class="text-[11px] text-emerald-400 font-semibold flex items-center gap-1">
            <span class="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse"></span>
            Concierge Online
          </span>
        </div>
        <!-- Close Button -->
        <div class="ml-auto flex items-center gap-3">
          <div
            class="w-8 h-8 rounded-full shrink-0 flex items-center justify-center action-button close-button cursor-pointer transition-all bg-white/5 border border-white/10 hover:bg-[#C71650] hover:border-[#E7CA96]"
            (click)="showHideChat()" role="button" aria-label="Close chat">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
        </div>
      </div>
    </div>

    <!-- Chat Messages Section -->
    <div #chatBody (scroll)="onScroll($event)" class="chat-messages flex flex-col p-6 chat-body" [ngClass]="{
        'overflow-y-auto': messages && messages.length > 0,
        'overflow-hidden': !messages || messages.length === 0,
        'chat-screen-input-focused': isInputFocused
      }">
      <!-- No Messages Welcome Screen -->
      <div *ngIf="!messages || messages.length === 0"
        class="flex flex-col items-center justify-center h-full text-center welcome-screen px-4">
        <div class="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#C71650]/30 to-[#E7CA96]/10 border border-[#E7CA96]/30 flex items-center justify-center mb-4 shadow-[0_0_25px_rgba(199, 22, 80,0.3)]">
          <img src="/mainLogo.webp" alt="Luckycrest" class="w-10 h-7 object-contain" />
        </div>
        <h2 class="text-white text-xl font-bold mb-2 tracking-wide">
          Luckycrest Concierge
        </h2>
        <p class="text-[#C2ABA3] text-xs max-w-xs leading-relaxed mb-4">
          Welcome to VIP Support. How can we assist you with your games, account, or transactions today?
        </p>
        <span class="text-[10px] text-[#E7CA96]/70 uppercase tracking-widest font-bold">
          Typical response time: Instant
        </span>
      </div>

      <!-- Messages Display -->
      <div *ngFor="let message of messages; trackBy: trackByMessageId" class="w-full flex my-1" [ngClass]="{
          'justify-end':
            message?.MessageFrom == 'Customer' ||
            message?.SenderId == getUserId(),
          'justify-start': message?.MessageFrom != 'Customer'||
            message?.SenderId != getUserId(),
        }">
        <!-- Customer Message (New Clean Design) -->
        <div *ngIf="
            message?.MessageType != 'UnEngaged' &&
            (message?.MessageFrom == 'Customer' ||
              message?.SenderId == getUserId())
          " class="max-w-[80%] flex flex-col items-end">

          <!-- Timestamp outside the bubble -->
          <div class="flex justify-between w-full px-1 mb-1">
            <span class="text-[10px] text-gray-300 font-medium tracking-wide">
              {{ message?.SenderName || 'You' }}
            </span>
            <span class="text-[9px] text-gray-400">
              {{ message?.Time | localTime }}
            </span>
          </div>

          <!-- Message Bubble with Clean Design -->
          <div
            class="customer-message-bubble text-white rounded-md px-3 py-3 shadow-sm break-words w-fit max-w-full relative overflow-hidden">
            <!-- Image handling (preserved logic) -->
            <div *ngIf="message.ImageUrl" class="image-container relative mb-2 max-w-full mt-1">
              <img loading="lazy" [src]="message?.ImageUrl" alt="Selected Image"
                class="w-full max-w-sm h-auto rounded-lg cursor-pointer hover:opacity-90 transition-opacity"
                (click)="openImageModal(message.ImageUrl)" />
            </div>

            <!-- Message Text -->
            <p style="
                line-height: normal;
                margin: 0;
                margin-bottom: 16px;
                word-wrap: break-word;
                word-break: normal;
                overflow-wrap: break-word;
                white-space: pre-wrap;
                font-size: 14px;
              ">
              {{ message?.Message }}
            </p>

            <!-- Blue double tick inside message bubble -->
            <div class="w-max absolute right-[8px] bottom-[6px]">
              <span class="message-status w-full float-right justify-end flex-row-reverse">
                <!-- Double tick seen (blue) -->
                <fa-icon *ngIf="message.IsDelivered && message.IsSeen" [icon]="CheckDouble"
                  class="text-blue-400 text-sm" title="Seen"></fa-icon>
                <!-- Double tick delivered (gray) -->
                <fa-icon *ngIf="message.IsDelivered && !message.IsSeen" [icon]="CheckDouble"
                  class="text-gray-400 text-sm" title="Delivered"></fa-icon>
                <!-- Single tick sent (gray) -->
                <fa-icon *ngIf="!message.IsDelivered" [icon]="Check" class="text-gray-400 text-sm"
                  title="Sent"></fa-icon>
              </span>
            </div>
          </div>
        </div>

        <!-- Support/Agent Message (New Clean Design) -->
        <div *ngIf="
            message?.MessageType != 'UnEngaged' &&
            message?.MessageFrom != 'Customer' &&
            message?.SenderId != getUserId()
          " class="max-w-[80%] flex flex-col items-start">
          <!-- Timestamp outside the bubble -->
          <div class="flex justify-between w-full px-1 mb-1">
            <span class="text-[10px] text-gray-300 font-medium tracking-wide">
              Customer Support
            </span>
            <span class="text-[9px] text-gray-400">
              {{ message?.Time | localTime }}
            </span>
          </div>

          <!-- Message Bubble with Clean Design -->
          <div
            class="support-message-bubble text-white rounded-md px-3 py-3 shadow-sm break-words w-fit max-w-full overflow-hidden">
            <!-- Image handling (preserved logic) -->
            <div *ngIf="message.ImageUrl" class="image-container relative mb-2 max-w-full mt-1">
              <img loading="lazy" [src]="message?.ImageUrl" alt="Selected Image"
                class="w-full max-w-sm h-auto rounded-lg border border-[var(--modal-border)] cursor-pointer hover:opacity-90 transition-opacity"
                (click)="openImageModal(message.ImageUrl)" />
            </div>

            <!-- Message Text -->
            <p style="
                line-height: normal;
                margin: 0;
                white-space: pre-wrap;
                word-wrap: break-word;
                word-break: normal;
                overflow-wrap: break-word;
              ">
              {{ message?.Message }}
            </p>
          </div>
        </div>
        <div *ngIf="message.MessageType == 'UnEngaged'" class="hell">
          <div class="text-gray-400 text-sm p-2 w-full text-center fixed bottom-4 left-1/2 transform -translate-x-1/2">
            <p class>chat session has ended</p>
          </div>
        </div>
      </div>
    </div>
    <!-- <ng-template #noChatFound>
      <div
        class="flex flex-col items-center h-[58dvh] justify-center text-white p-6 rounded-lg"
      >
        <div class="relative">
          <div
            class="absolute top-2 left-2 bg-teal-400 p-4 rounded-lg text-white"
          >
            <span class="flex space-x-1">
              <span class="w-2 h-2 bg-white rounded-full"></span>
              <span class="w-2 h-2 bg-white rounded-full"></span>
              <span class="w-2 h-2 bg-white rounded-full"></span>
            </span>
          </div>
          <div class="bg-teal-200 p-6 rounded-lg ml-6 mt-6"></div>
        </div>
        <h4 class="text-gray-300 mt-4">Start Conversation.</h4>
      </div>
    </ng-template> -->

    <!-- Display Selected in input Image -->
    <div *ngIf="imageURL" class="selected-image-preview -mb-2 w-48 ml-2 selected-image-shown relative">
      <img loading="lazy" [src]="imageURL" alt="Selected Image"
        class="w-full h-auto max-h-32 rounded-xl border border-[var(--modal-border)] object-contain" />
      <button (click)="clearSelection()"
        class="absolute top-1 right-1 bg-[var(--modal-bg-secondary)] text-white rounded-full p-1 hover:bg-red-500 transition-colors z-10 border border-[var(--modal-border)]">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="currentColor" viewBox="0 0 24 24">
          <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
    </div>

    <!-- Display Selected Image End-->

    <!-- Input Area -->
    <div class="chat-input flex-shrink-0 relative">
      <div class="chat-composer">
        <!-- Plus Button -->
        <button (click)="toggleOptionsMenu()"
          class="plus-button composer-button composer-button-left transition-all duration-300">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
          </svg>
        </button>

        <!-- Input Field -->
        <div class="composer-input-wrap">
          <textarea (focus)="onInputFocus()" (blur)="onInputBlur()" (paste)="onPaste($event)" type="text"
            [(ngModel)]="newMessage" (keydown)="onTextareaKeydown($event)" (input)="adjustHeight($event)"
            placeholder="Type a message..." rows="1"
            class="composer-textarea text-white outline-none resize-none custom-textarea border-0"
            style="overflow-y: hidden;"></textarea>
        </div>

        <!-- Send Button -->
        <button (click)="sendMessage($event)"
          class="send-button composer-button composer-button-send transition-all duration-300 text-white">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"
            style="transform: rotate(45deg); margin-left: 2px;">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
          </svg>
        </button>

        <!-- Options Menu -->
        <div *ngIf="showOptionsMenu"
          class="absolute left-0 bottom-full mb-2 bg-[var(--modal-bg-secondary)] border border-[var(--modal-border)] rounded-xl shadow-lg z-10 w-40 p-2">
          <!-- <button (click)="openCamera()"
            class="flex items-center gap-2 p-2 text-gray-400 hover:bg-[#303137] hover:text-white rounded-md w-full transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-gray-400" fill="currentColor"
              viewBox="0 0 512 512">
              <path
                d="M149.1 64.8L138.7 96 64 96C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-74.7 0L362.9 64.8C356.4 45.2 338.1 32 317.4 32L194.6 32c-20.7 0-39 13.2-45.5 32.8zM256 192a96 96 0 1 1 0 192 96 96 0 1 1 0-192z" />
            </svg>

            <span> Camera</span>
          </button> -->
          <!-- Camera View -->
          <div *ngIf="isCameraOpen"
            class="fixed inset-0 bg-gradient-to-br from-purple-600 to-purple-800bg-opacity-50 flex items-center justify-center">
            <div class="bg-black p-4 rounded-lg">
              <video #videoElement autoplay playsinline [hidden]="showPreview"></video>
              <canvas #canvasElement style="display: none"></canvas>

              <!-- Captured Image Preview -->
              <img loading="lazy" *ngIf="showPreview" [src]="capturedImage" class="max-w-full h-auto" />

              <div class="flex justify-center gap-4 mt-4">
                <ng-container *ngIf="!showPreview">
                  <button class="camera-btn text-white p-2 bg-[#303137] rounded-full" (click)="capturePicture()">
                    <svg class="h-6 w-6 text-purple-400" xmlns="http://www.w3.org/2000/svg" fill="none"
                      viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round"
                        d="M6.827 6.175A2.31 2.31 0 0 1 5.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 0 0-1.134-.175 2.31 2.31 0 0 1-1.64-1.055l-.822-1.316a2.192 2.192 0 0 0-1.736-1.039 48.774 48.774 0 0 0-5.232 0 2.192 2.192 0 0 0-1.736 1.039l-.821 1.316Z" />
                      <path stroke-linecap="round" stroke-linejoin="round"
                        d="M16.5 12.75a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM18.75 10.5h.008v.008h-.008V10.5Z" />
                    </svg>
                  </button>
                </ng-container>

                <ng-container *ngIf="showPreview">
                  <button class="camera-btn p-2 bg-[#303137] rounded-full" (click)="retakePhoto()">
                    <svg class="h-6 w-6 text-purple-400" xmlns="http://www.w3.org/2000/svg" fill="none"
                      viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round"
                        d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
                    </svg>
                  </button>
                </ng-container>

                <button class="bg-[#303137] p-2 bg-[#30313 rounded-full" (click)="closeCamera()">
                  <svg class="h-6 w-6 text-purple-400" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <!-- Camera View End -->

          <!-- Gallery Image Selection -->

          <button (click)="triggerFileInput(fileInput)"
            class="flex items-center gap-2 p-2 text-[var(--modal-text-muted)] hover:text-[var(--modal-text)] hover:bg-[var(--modal-surface)] rounded-lg w-full transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-[var(--modal-text-muted)]" fill="currentColor"
              viewBox="0 0 512 512">
              <path
                d="M448 80c8.8 0 16 7.2 16 16l0 319.8-5-6.5-136-176c-4.5-5.9-11.6-9.3-19-9.3s-14.4 3.4-19 9.3L202 340.7l-30.5-42.7C167 291.7 159.8 288 152 288s-15 3.7-19.5 10.1l-80 112L48 416.3l0-.3L48 96c0-8.8 7.2-16 16-16l384 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm80 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z" />
            </svg>
            <span>Gallery</span>
          </button>
          <input (paste)="onPaste($event)" type="file" #fileInput accept="image/*" style="display: none"
            (change)="onFileSelected($event)" />
          <!-- Gallery Image Selection End -->
        </div>
      </div>
    </div>

    <!-- Image Modal -->
    <div #imageModal class="modal" (click)="closeImageModal()">
      <span class="close" (click)="closeImageModal()">&times;</span>
      <img loading="lazy" class="modal-content" [src]="selectedImageUrl" alt="Image Preview" />
      <a *ngIf="selectedImageUrl" [href]="selectedImageUrl" download="image.jpg" class="download-button">
        <fa-icon [icon]="Download" class="text-2xl"></fa-icon>
      </a>
    </div>
    <!-- Input Area  End -->
  </div>
</div>